export default __webpack_public_path__ + "static/media/prenatalLandingPageBanner.e0650e45.jpg";